import { render, staticRenderFns } from "./assetPack.vue?vue&type=template&id=f5467984&scoped=true"
import script from "./assetPack.vue?vue&type=script&lang=js"
export * from "./assetPack.vue?vue&type=script&lang=js"
import style0 from "./assetPack.vue?vue&type=style&index=0&id=f5467984&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5467984",
  null
  
)

export default component.exports